export function apiErrorMessage(error, fallback = 'Something went wrong.') {
  const data = error?.response?.data;
  if (data == null || data === '') return fallback;
  if (typeof data === 'string') return data;

  if (typeof data === 'object') {
    if (typeof data.message === 'string' && data.message) return data.message;
    if (typeof data.title === 'string' && data.title) return data.title;
    if (typeof data.detail === 'string' && data.detail) return data.detail;
    if (typeof data.error === 'string' && data.error) return data.error;

    if (data.errors && typeof data.errors === 'object') {
      const msgs = [];
      Object.keys(data.errors).forEach((key) => {
        const v = data.errors[key];
        if (Array.isArray(v)) msgs.push(...v.map(String));
        else if (v != null) msgs.push(String(v));
      });
      if (msgs.length) return msgs.join(' ');
    }
  }

  try {
    return typeof data === 'object' ? JSON.stringify(data) : String(data);
  } catch {
    return fallback;
  }
}
